import MessageCard from "components/MessageCard/MessageCard";
import Scrollbars from "components/Scrollbars/Scrollbars";
import SuggestionCard from "components/SuggestionCard/SuggestionCard";
import React from "react";
import { connect } from "react-redux";
import "./Suggestions.scss";

function Suggestions(props) {
  const { activeSuggestion } = props;

  return activeSuggestion !== null ? (
    <div className={`suggestions-container`}>
      <Scrollbars className="scrollable-suggestions">
        <div className="message-of-suggestions">
          <MessageCard message={activeSuggestion} messageSource="from" />
        </div>
        <div className="suggestions-list">
          {activeSuggestion.suggestions.map((suggestion, index) => (
            <SuggestionCard
              className="suggestion-item"
              key={index}
              suggestion={suggestion}
              suggestionInfo={{
                messageIdOfSuggestion: activeSuggestion.messageId,
                suggestionIndex: index,
              }}
            />
          ))}
        </div>
      </Scrollbars>
    </div>
  ) : (
    <div className="empty-suggestions">
      Please choose a message to show suggestions
    </div>
  );
}

const mapStateToProps = (state) => ({
  activeSuggestion: state.suggestion.activeSuggestion,
});

export default connect(mapStateToProps)(Suggestions);
